<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="CN ParaOverride-6" id="_idParaDest-6"><span class="CharOverride-10">Wisdom comes to us when it can no longer do any good.</span></p>
<p class="BT-1st ParaOverride-9" xml:lang="en-US"><span class="CharOverride-2">—</span>Gabriel García Márquez</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eBook_V45575.vue?592b575b